module.exports = __webpack_public_path__ + "media/images/safari-7ad85b275bba6ff0a2a7d419b644fe9a.svg";